module.exports = "/images/vendor/flag-icon-css/flags/4x3/my.svg?e6739f404c969d6225b48df00169ca8f";